import { IQuotes } from "models/Quote";
import { ITableModel } from "components/Table/interface";
import { IBudgetDropdown } from "pages/Quotes/components/Dropdown/BudgetDropdown/interface";
import { IPreOrders } from "pages/Quotes/components/Dropdown/PortalOrderDropdown/interface";

export interface DropdownTemplateProps {
  Order?: React.FC<IPreOrders>;
  Quote?: React.FC<IBudgetDropdown>;
}

export interface TablePortalProps {
  onReload?: any;
  error?: boolean;
  tableOrder?: any;
  data?: Array<any>;
  pageSize?: number;
  onPageChange?: any;
  className?: string;
  rowHeight?: number;
  setTableOrder?: any;
  totalPages?: number;
  isRanking?: boolean;
  trackingKey?: string;
  currentPage?: number;
  redirectUrl?: string;
  DropdownTemplate?: DropdownTemplateProps;
  showPagination?: boolean;
  orderRadioSelected?: boolean;
  model: Array<ITableModel>;
  completeBlankSpaces?: boolean;
  columnsSize?: Array<number | string>;
  renderButton?: (quoteItem: IQuotes) => JSX.Element;
  bottomButton?: {
    label: string;
    linkTo: string;
  };
  noDataText?: string;
  customProps?: {
    [key: string]: any;
  };
}

export const statusLockedButton = ["OPEN", "CLOSED"];

export const supplierStatusLockedButton = [
  "EXPIRED",
  "NEGOTIATION",
  "UNAVAILABLE",
  "VALIDATE_PORTAL",
  "DO_NOT_PARTICIPATE",
  "WAITING_PRIORITIZATION",
  "DISREGARDED"
];

export const supplierStatusSent = [
  "NEGOTIATION",
  "UNAVAILABLE",
  "QUEUE_MONEY",
  "UNAVAILABLE",
  "QUEUE_BIONEXO",
  "PENDING_MONEY",
  "ANSWERED_MONEY",
  "ANSWERED_PORTAL",
  "AUTOMATIC_ANSWER",
  "ANSWERED_PORTAL_MONEY",
];

export const statusSent = [
  "OPEN",
  "SENT",
  "CLOSED",
  "UPDATED",
  "CANCELED",
  "PROCESSING",
  "NEGOTIATION",
  "PURCHASE_ORDER",
];

export const orderStatus = ["CONFIRMED", "CANCELED"];

export const statusProcessing = [
  "PROCESSING"
];